import script from "./AddTemporaryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddTemporaryModal.vue?vue&type=script&setup=true&lang=js"

import "./AddTemporaryModal.vue?vue&type=style&index=0&id=1a0e1890&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a0e1890"]])

export default __exports__